module.exports = __webpack_public_path__ + "img/mruDetails2.c08e4595.jpg";